import { gql } from "@apollo/client";

export const CHECK_AFFILIATE_LINK = gql`
  query checkAffiliateLink($link: String!){
    checkAffiliateLink(link:$link)
  }
`;
